import { fetch } from '@fyresite/fetch';

export const USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_VERIFIED_SUCCESS = 'USER_VERIFIED_SUCCESS';
export const USER_VERIFIED_FAILURE = 'USER_VERIFIED_FAILURE';
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
export const USER_LOGOUT_FAILURE = 'USER_LOGOUT_FAILURE';

export function login(email, password) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      let status;

      fetch('/api/v1/session/create', {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: email,
          password: password
        })
      }).then(res => {
        status = res.status;

        return res.json();
      }).then(payload => {
        let type;
        let code = payload.code;
        if (status === 200 && code === 200) {
          let user = payload.result.user;
          type = USER_LOGIN_SUCCESS;
          dispatch({ type, payload: user });
          resolve({ type, user });
        } else {
          type = USER_LOGIN_FAILURE;
          dispatch({ type, payload: payload });
          resolve({ type, payload });
        }
      }).catch(err => {
        console.error(err);
        dispatch({ type: USER_LOGIN_FAILURE, payload: err });
        reject(err);
      });
    });
  }
}

export function verify() {
  return dispatch => {
    return new Promise((resolve, reject) => {
      let status;

      fetch('/api/v1/session/read').then(res => {
        status = res.status;

        return res.json();
      }).then(payload => {
        let type;
        let user = payload.result.user;

        if (status === 200) {
          type = USER_VERIFIED_SUCCESS;
        } else {
          type = USER_VERIFIED_FAILURE;
        }

        dispatch({ type, payload: {} });
        resolve({ type, user });
      }).catch(err => {
        console.error(err);
        dispatch({ type: USER_VERIFIED_FAILURE, payload: {} });
        reject(err);
      });
    });
  }
}


export function logout() {
  return dispatch => {
    return new Promise((resolve, reject) => {
      let status;

      fetch('/api/v1/session/delete', {
        method: 'POST',
        headers: { "Content-Type": "application/json" }
      }).then(res => {
        status = res.status;

        return res.json();
      }).then(payload => {
        let type;
        let user = payload.result.user;

        if (status === 200) {
          type = USER_LOGOUT_SUCCESS;
        } else {
          type = USER_LOGOUT_FAILURE;
          reject(status);
        }

        dispatch({ type, payload: {} });
        resolve({ type, user });
      }).catch(err => {
        console.error(err);
        dispatch({ type: USER_LOGIN_FAILURE, payload: err });
        reject(err);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/user.js